module.exports = __webpack_public_path__ + "static/media/03A.4144dde9.png";